module.exports = __webpack_public_path__ + "img/join_wealth.6f8d5f5b.svg";